import { InitParams } from '@wix/wix-help-widget-common/types';

import { dispatch } from '../store';
import { widgetModel } from '../widgetModel';

export const isWidgetDisabled = (initParams: InitParams) => {
  if (!initParams || !initParams.origin) {
    throw new Error('Must pass an origin');
  }
  const experiments = widgetModel.getExperiments();
  return [
    experiments.enabled('specs.chatbot.SdkInMaintenanceAllUsers'),
    experiments.enabled('specs.support.LessCapabilitiesForSupportUser'),
  ].some(Boolean);
};

export const onWidgetFailure = (error: Error) => {
  dispatch('app/setHasFatalError', true);
  console.error('runWidgetApp', error.message);
};
